import WaveBackground from './WaveBackground';

export default WaveBackground;
